/**
 * This handles custom events
 */

export default {
    event: null,
    callbacks: [],
    /**
     * Create and emit event
     * @param name
     * @param data
     */
    emit(name, data = {}) {
        // Create
        this.event = new CustomEvent("vue-" + name, {
            detail: data,
        });
        // Listen
        window.addEventListener( "vue-" + name, (e) => {
            this.callbacks.forEach((data) => {
                if ( data.name === name && typeof data.callback === "function") {
                    data.callback(e.detail);
                }
            });
        }, {passive: true});
        // Dispatch
        window.dispatchEvent(this.event);
    },
    /**
     * Receive the event and callback
     * @param name
     * @param callback
     */
    receive(name, callback) {
        this.callbacks.push({
            name: name,
            callback: callback,
        });
    }
};



